/**
 * Copyright (c) 2022 ForgeRock. All rights reserved.
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */

export const Position = Object.freeze({
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right',
});

export const DatasetSize = Object.freeze({
  SMALL: 'sm',
  LARGE: 'lg',
  CUSTOM: 'cm',
});
